/**
* @module index
* @author: zhangyemei
* @description:
* @since: 2020-05-23 17:52:42
*/
import React, { Component } from 'react';
import { Decrypt, Encrypt } from '@/utils/encrypt.js';
import { Dropdown, Menu, Input } from 'antd';
import history from '@/router/history';
const {
  SubMenu
} = Menu;
const {
  Search
} = Input;
import QRCode from 'qrcode.react';
import { Local } from '@/utils/local.js';
import { footerThemeColor } from '@/utils/themeColor.js';
import intl from 'react-intl-universal';
import LogoSchool from '../LogoSchool';
import UserInfo from '../UserInfo';
import './style.less';

const logoUrl = require('@/statics/img/logo.png');

export default class index extends Component {
  state = {
    userId: Local.get('userInfo') && JSON.parse(Decrypt(Local.get('userInfo'))).userId ? Number(JSON.parse(Decrypt(Local.get('userInfo'))).userId) : null,
    baseUrl: window.location.origin,
    baseInfo: this.props.baseInfo,
    schoolList: this.props.schoolList,
    headMenuList: this.props.headMenuList,
    personConfigInfo: this.props.personConfigInfo,
    currentUserInfo: this.props.currentUserInfo,
    appConfig: this.props.appConfig,
    learnData: this.props.learnData,
    origin: window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://ts.dev-s.yunduoketang.cn'
  };

  componentDidMount() {}

  searchCourse = value => {
    value = encodeURI(value);
    history.push(`/course/list?courseName=${value}`); // window.open(`${this.state.origin}/sysConfigItem/showList?n=${value}`)
  };

  render() {
    const {
      state
    } = this;
    const {
      schoolList,
      showSchoolList,
      baseInfo,
      currentSchoolName,
      appConfig,
      personConfigInfo,
      currentUserInfo,
      personal,
      unreadMessage,
      lateLearnShow,
      headMenuList,
      learnData,
      dropVisible,
      currentMenu
    } = this.props; //APP下载

    console.log('this.props.currentMenu', this.props.currentMenu);
    const appLoad = <div data-inspector-line="58" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="load-box">
        <div data-inspector-line="59" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="load-top">
          {appConfig.scanDownURL ? <img data-inspector-line="61" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="img-qrcode" src={appConfig.scanDownURL} alt="" /> : null}
          {appConfig.iosDownURL || appConfig.androidDownURL ? <div data-inspector-line="64" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="load-type">
              <p data-inspector-line="65" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx">手机客户端下载</p>
              {appConfig.iosDownURL ? <p data-inspector-line="67" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx">
                  <i data-inspector-line="68" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="iconfont iconpingguo"></i>
                  <a data-inspector-line="69" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" href={appConfig.iosDownURL} target="_blank">iphone下载</a>
                </p> : null}
              {appConfig.androidDownURL ? <p data-inspector-line="73" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx">
                  <i data-inspector-line="74" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="iconfont iconanzhuo"></i>
                  <a data-inspector-line="75" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" href={appConfig.androidDownURL} target="_blank">安卓下载</a>
                </p> : null}
            </div> : null}
        </div>

        {appConfig.schoolURL ? <div data-inspector-line="83" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="load-bottom">
            <QRCode data-inspector-line="84" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="img-qrcode" size={112} fgColor="#000000" value={appConfig.schoolURL} />
            <div data-inspector-line="90" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx">打开APP，扫描网校二维码进入学习</div>
          </div> : null}
      </div>;
    return <React.Fragment>
        <div data-inspector-line="98" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="navbar navbar_wind cf">
          <LogoSchool data-inspector-line="99" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" {...{
          schoolList,
          showSchoolList,
          baseInfo,
          currentSchoolName,
          dropVisible
        }} handleSchoolClick={this.props.handleSchoolClick} history={this.props.history} showDorpMenu={this.props.showDorpMenu} />
          <div data-inspector-line="103" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="search_area">
            <input data-inspector-line="104" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" type="password" style={{
            display: 'none'
          }} />
            <Search data-inspector-line="105" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" placeholder="搜索你感兴趣的课程" enterButton='搜索' style={{
            width: '500px',
            marginLeft: '20px',
            height: '40px'
          }} onSearch={value => this.searchCourse(value)} />
          </div>

          <div data-inspector-line="113" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="right">
            {
            /* <span className="csp" onClick={this.props.handleSwitchLang}>{this.props.langText}</span> */
          }
            {//APP下载
          personConfigInfo.includes('HEAD_APP') && appConfig && !appConfig.appConfigStatus ? <Dropdown data-inspector-line="117" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="user-info" overlay={appLoad}>
                  <div data-inspector-line="118" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" style={{
              cursor: 'pointer'
            }} onClick={this.props.goToAppDown}><i data-inspector-line="118" data-inspector-column="86" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="iconfont iconshouji">&nbsp;</i>{intl.get('appDownLoad')}</div>
                </Dropdown> : null}
            <UserInfo data-inspector-line="121" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" {...{
            appConfig,
            personConfigInfo,
            currentUserInfo,
            personal,
            unreadMessage,
            lateLearnShow,
            personConfigInfo,
            learnData
          }} changeMenu={this.props.changeMenu} />
          </div>
        </div>
        <div data-inspector-line="124" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="menu-area">
          <div data-inspector-line="125" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="menu-bg">
            <Menu data-inspector-line="126" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" onClick={this.props.handleNavMenuClick} selectedKeys={[this.props.currentMenu]} mode="horizontal">
              {headMenuList.map((item, index) => <SubMenu data-inspector-line="132" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" key={index} className={`submenu ${this.props.currentMenu == index ? 'ant-menu-item-selected' : ''}`} title={<span data-inspector-line="136" data-inspector-column="20" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" className="submenu-title-wrapper" onMouseOver={() => this.props.handleMenuMouseOver(item)} onClick={() => this.props.handleMenuClick(item, 'head', index)}>
                      {item.menuName}
                    </span>}>
                  {item.subMenu.map((subItem, subIndex) => <Menu.Item data-inspector-line="145" data-inspector-column="22" data-inspector-relative-path="src\\containers\\Layout\\Header\\WindHeader\\index.jsx" key={subIndex} onClick={() => this.props.handleMenuClick(subItem, 'head', subIndex)}>{subItem.menuName}</Menu.Item>)}
                </SubMenu>)}
            </Menu>
          </div>

        </div>
      </React.Fragment>;
  }

}